module.exports = __webpack_public_path__ + "img/03.9cf0fae8.jpg";